export default __webpack_public_path__ + "static/B0277-c39da0c048b39b43e4d96ff431b50b7f.png";